import {formatMasks, Options} from 'presentation/utils';

export const formatDetail = (value: string | undefined, type: Options) =>
	value ? formatMasks(type, value.toString()) : '-';
